import { jsx as _jsx } from "react/jsx-runtime";
import MealProductPage from './MealProductPage';
import MealSamplerProductListing from './MealSamplerProductPage';
import MealsProductListing from './MealsProductListing';
var MealsRoutes = [
    {
        path: 'meals',
        children: [
            { index: true, element: _jsx(MealsProductListing, {}) },
            { path: 'sampler-pack', element: _jsx(MealSamplerProductListing, {}) },
            {
                path: ':recipeName',
                element: _jsx(MealProductPage, {}),
            },
        ],
    },
];
export default MealsRoutes;
